import React from 'react';
import { Menu, Icon, Tooltip, Dropdown, Row, Col, Popover, message, Modal } from 'antd';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Skill from '../../images/logos/skill.png'
import Service from '../../images/logos/service.png'
import { firebaseConnect } from 'react-redux-firebase';
import { translate } from 'react-i18next';
import { history } from '../../store';
import { serviceTracker_allowed } from '../../config.js';
import Switch_dark from '../../images/Switch_dark.png';
import PDFLayout from '../../components/PDFLayout/serviceTracker.jsx';
require('../../styles/nav.css');
const SubMenu = Menu.SubMenu;

class Nav extends React.Component {

  menuClick = (e) => {

    if (e.key == 'logout') {
      this.props.firebase.logout()
    } else if (e.key == 'english') {
      this.props.changeLanguage('EN')
    } else if (e.key == 'french') {
      this.props.changeLanguage('FR')
    } else if (e.key == 'changetoSkilll') {
      this.handleChange('SkillTracker')
    } else if (e.key == 'changetoService') {
      this.handleChange('ServiceTracker')
    } else if (e.key == 'export') {
      message.info('Processing data...')
      this.props.getExportData()
        .then( () => {
          this.layout.toExport.save(() => {
            message.destroy()
            this.props.getExportData(true)
          })
        })
    }
  }

  changeProduct = (value) => {
    this.setState({ selectedProduct: value })
    this.props.selectProduct(value)

    if (value === 'SkillTracker') {
      this.props.history.push('/myclasses')
    } else {
      this.props.history.push('/servicetracker/progressoverview')
    }
  }

  showNotAvailable = () => {
    Modal.info({
      title: 'Oops!',
      content: "Looks like you don't have access to this service, please contact your school admin to let them know!"
    })
  }

  render() {
    let { t, lng, products, active } = this.props;
    if (!products) {
      products = []
    }
    if (this.props.selectedProduct == 'ServiceTracker') {
      active = false
    }

     let path;
     let url = history.location.pathname.split("/")[1];
     path = [history.location.pathname.split("/")[2]]
     if (!path) {
       path = ['generalinfo']
     }
     if (url == 'profile') {
       url = ['school']
     }


     const languages = (
       <Menu>
         <Menu.Item disabled={lng == 'EN'}>
           <div onClick={() => this.props.changeLanguage('EN')}>
             English
             {lng == 'EN' && <Icon style={{color: '#4a90e2', position: 'relative', bottom: 3, marginLeft: 10}} type="check" />}
           </div>
         </Menu.Item>
         <Menu.Item disabled={lng == 'FR'}>
           <div onClick={() => this.props.changeLanguage('FR')}>
             Français
             {lng == 'FR' && <Icon style={{color: '#4a90e2', position: 'relative', bottom: 3, marginLeft: 10}} type="check" />}
           </div>
         </Menu.Item>
       </Menu>
     )

     const productsBox = (
       <Row style={{width: 200}}>
         <Col className="productBox" xs={12} style={{border: '1px solid white', borderRadius: 3, cursor: products.includes('SkillTracker') ? 'pointer' : 'disabled'}} onClick={() => products.includes('SkillTracker') ? this.changeProduct('SkillTracker') : this.showNotAvailable()}>
           <img style={{width: 40, display: 'block', margin: '0 auto', marginTop: 20}} src={Skill} />
           <h3 style={{fontSize: 12, color: '#8ca0b3', marginBottom: 0, marginTop: 10, textAlign: 'center', fontFamily: 'Arial Rounded MT Bold' }}>Skill</h3>
           <h3 style={{fontSize: 12, color: '#8ca0b3', marginBottom: 10, textAlign: 'center', fontFamily: 'Arial Rounded MT Bold'}}>Tracker</h3>
         </Col>
         <Col className="productBox" xs={12} style={{border: '1px solid white', borderRadius: 3, cursor: products.includes('ServiceTracker') ? 'pointer' : 'disabled'}} onClick={() => products.includes('ServiceTracker') ? this.changeProduct('ServiceTracker') : this.showNotAvailable()}>
           <img style={{width: 40, display: 'block', margin: '0 auto', marginTop: 20}} src={Service} />
           <h3 style={{fontSize: 12, color: '#8ca0b3', marginBottom: 0, marginTop: 10, textAlign: 'center', fontFamily: 'Arial Rounded MT Bold' }}>Service</h3>
           <h3 style={{fontSize: 12, color: '#8ca0b3', marginBottom: 10, textAlign: 'center', fontFamily: 'Arial Rounded MT Bold'}}>Tracker</h3>
         </Col>
       </Row>
     )

    if (active) {
      return (
        <Menu onClick={this.menuClick} selectedKeys={path} mode="horizontal" style={this.props.role == 'teacher' ? style : {height: '82px'}}>
          <Menu.Item key="generalinfo"><Link to={`/${url}/generalinfo`}>{t('General Information')}</Link></Menu.Item>
          <Menu.Item key="overview"><Link to={`/${url}/overview`}>{t('Category View')}</Link></Menu.Item>
          <Menu.Item key="specs"><Link to={`/${url}/specs`}>{t('Cluster View')}</Link></Menu.Item>
          <Menu.Item key="skillsoverview"><Link to={`/${url}/skillsoverview`}>{t('Skills Overview')}</Link></Menu.Item>
          <Menu.Item key="skills"><Link to={`/${url}/skills`}>{t('Skills Logged')}</Link></Menu.Item>
          {this.props.name &&  <div style={{width: 'max-content', display: 'inline-block', position:'absolute', right:140, color: '#8ca0b3', top: 33}}>{t('Hi,')} {this.props.name}</div> }
          {serviceTracker_allowed &&
            <Menu.Item className="noBorderBottom" style={{position: 'absolute', right: 70, top: 35}}>
              <Popover content={productsBox} placement="bottom">
                <img style={{width: 25}} src={Switch_dark} />
              </Popover>
            </Menu.Item>
          }
          <SubMenu className="noBorderBottom" style={{position: 'absolute', right: 20, top: 43, paddingBottom: 10 }} title={<span className="submenu-title-wrapper"><Icon style={{color: '#8ca0b3'}} type="user" /></span>}>
            {this.props.selectedProduct == 'SkillTracker' &&
              <Menu.ItemGroup title={
                <div style={{display: 'table'}}>
                  <Icon style={{marginRight: 5}} type="global" /> <span style={{position: 'relative', top: 3}}>{t('Language')}</span>
                </div>
              }
              >
                <Menu.Item disabled={this.props.language == 'EN'}  key="english">English {this.props.language == 'EN' &&  <Icon style={{position: 'relative', bottom: 3, marginLeft: 5}} type="check-circle" />}</Menu.Item>
                <Menu.Item disabled={this.props.language == 'FR'} key="french">Français {this.props.language == 'FR' &&  <Icon style={{position: 'relative', bottom: 3, marginLeft: 5}} type="check-circle" />}</Menu.Item>
              </Menu.ItemGroup>
            }
            {this.props.role && this.props.role !== 'admin' &&
              <Menu.Item key="changePass">
                <Link to="/profile">
                  <Icon style={{marginRight: 5}} type="setting" /> <span style={{position: 'relative', top: 3}}>{t('Change Password')}</span>
                </Link>
              </Menu.Item>
            }
              {this.props.selectedProduct == 'ServiceTracker' && <Menu.Item key="export"><Icon style={{marginRight: 5}} type="file-pdf" /> <span style={{position: 'relative', top: 3}}>{t('Export PDF')}</span></Menu.Item>}
              <Menu.Item key="logout"><Icon style={{marginRight: 5}} type="logout" /> <span style={{position: 'relative', top: 3}}>{t('Logout')}</span></Menu.Item>
          </SubMenu>

        </Menu>
      )
    } else {
      return (
        <Menu onClick={this.menuClick} defaultSelectedKeys={this.props.location} mode="horizontal" style={this.props.role == 'teacher' ? style : {height: '82px'}}>

        {(this.props.role && this.props.role == 'teacher' && serviceTracker_allowed )&&
          <Menu.Item className="noBorderBottom" style={{position: 'absolute', right: 70, top: 35}}>
            <Popover content={productsBox} placement="bottom">
              <img style={{width: 25}} src={Switch_dark} />
            </Popover>
          </Menu.Item>
        }


          <SubMenu className="noBorderBottom" style={{position: 'absolute', right: 20, top: 43, paddingBottom: 10 }} title={<span className="submenu-title-wrapper"><Icon style={{color: '#8ca0b3'}} type="user" /></span>}>
          {this.props.selectedProduct !== 'ServiceTracker' &&
              <Menu.ItemGroup  title={
                <div style={{display: 'table'}}>
                  <Icon style={{marginRight: 5}} type="global" /> <span style={{position: 'relative', top: 3}}>{t('Language')}</span>
                </div>
              }>
                <Menu.Item disabled={this.props.language == 'EN'}  key="english">English {this.props.language == 'EN' &&  <Icon style={{position: 'relative', bottom: 3, marginLeft: 5}} type="check-circle" />}</Menu.Item>
                <Menu.Item disabled={this.props.language == 'FR'} key="french">Français {this.props.language == 'FR' &&  <Icon style={{position: 'relative', bottom: 3, marginLeft: 5}} type="check-circle" />}</Menu.Item>
              </Menu.ItemGroup>
          }
          {this.props.role && this.props.role !== 'admin' &&
              <Menu.Item key="changePass">
                <Link to="/profile">
                  <Icon style={{marginRight: 5}} type="setting" /> <span style={{position: 'relative', top: 3}}>{t('Change Password')}</span>
                </Link>
              </Menu.Item>
          }
              {this.props.role && this.props.role == 'admin' &&
                <Menu.Item  style={{marginLeft:0, display: 'none'}} key="settings"><Link to="/school-settings"><Icon style={{marginRight: 5}} type="setting" /> <span style={{position: 'relative', top: 3}}>{t('School Settings')}</span></Link></Menu.Item>
              }
              {this.props.selectedProduct == 'ServiceTracker' && <Menu.Item key="export"><Icon style={{marginRight: 5}} type="file-pdf" /> <span style={{position: 'relative', top: 3}}>{t('Export PDF')}</span></Menu.Item>}
              <Menu.Item key="logout"><Icon style={{marginRight: 5}} type="logout" /> <span style={{position: 'relative', top: 3}}>{t('Logout')}</span></Menu.Item>
          </SubMenu>
          {this.props.exportData &&
            <PDFLayout
              profile={this.props.profile}
              ref={(r) => this.layout = r}
              data={this.props.exportData}
            />
          }
          {this.props.name && <div style={{ width: 'max-content', display: 'inline-block', position: 'absolute', right: 140, color: '#8ca0b3', top: 33 }}>{t('Hi,')} {this.props.name}</div>}
        </Menu>
      )
    }
  }
}

const style = {
  height: 82,
  position: 'fixed',
  top: 0,
  zIndex: 1,
  width: '100%',
  paddingLeft: 230,
  boxShadow: 'rgb(217, 228, 236) -5px 7px 11px 0px',
  marginLeft: 10,
  maxWidth: 1272,
  paddingRight: 20,
  zIndex: 2
}

const enhancer = compose(
  firebaseConnect(),
  translate('lang'),
)
export default enhancer(Nav);



// WEBPACK FOOTER //
// ./src/components/Nav/index.jsx